import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutGuide from './components/AboutGuide';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import CTASection from './components/CTASection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <AboutGuide />
        <CategoryGrid />
        <ComparisonSection />
        <CTASection />
        <SafetySection />
        <FAQSection />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
}